/* Hanger Uniforms — global theme JS */
(function () {
  'use strict';

  /* ---- Mobile nav ---- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    var close = nav.querySelector('[data-menu-close]');
    function open() { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function shut() { nav.classList.remove('is-open'); document.body.style.overflow = ''; }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    nav.addEventListener('click', function (e) { if (e.target.tagName === 'A') shut(); });
  }

  /* ---- Product gallery thumbnails ---- */
  function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (main && full) main.src = full;
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---- Quantity steppers ---- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
          var min = parseInt(input.min || '1', 10);
          var val = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, val);
          input.dispatchEvent(new Event('change'));
        });
      });
    });
  }

  /* ---- File upload zones (quote / product / upload page) ---- */
  function initFileDrop() {
    document.querySelectorAll('[data-file-drop]').forEach(function (drop) {
      var input = drop.querySelector('input[type="file"]');
      var names = drop.querySelector('[data-file-names]');
      if (!input) return;
      function show() {
        if (!names) return;
        if (input.files.length) {
          var list = [];
          for (var i = 0; i < input.files.length; i++) list.push(input.files[i].name);
          names.textContent = list.join(', ');
        } else { names.textContent = ''; }
      }
      drop.addEventListener('click', function (e) { if (e.target !== input) input.click(); });
      input.addEventListener('change', show);
      ['dragover', 'dragenter'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); });
      });
      drop.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files.length) { input.files = e.dataTransfer.files; show(); }
      });
    });
  }

  /* ---- Sticky header shadow ---- */
  function initHeaderShadow() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.style.boxShadow = window.scrollY > 8 ? '0 4px 20px rgba(15,42,74,0.08)' : 'none';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initProductGallery();
    initQty();
    initFileDrop();
    initHeaderShadow();
  });
})();
